import React, { useState } from "react";
import { BsArrowClockwise } from "react-icons/bs";

import useFetchCsrfToken from "../../0. Utilidades/useFetchCsrfToken";
import "../Maestra.css";

function Bios({
  maestraRut,
  bios,
  tipo,
  relacion,
  biosAiUpdatedAt,
  biosAiUpdateStartedAt,
  onBiosUpdate,
  onEstadoUpdate,
}) {
  const [isTogglingEstado, setIsTogglingEstado] = useState(false);
  const [isGeneratingStory, setIsGeneratingStory] = useState(false);
  const [storyError, setStoryError] = useState("");

  const csrfToken = useFetchCsrfToken();
  const aiUpdateStartedAt = biosAiUpdateStartedAt
    ? new Date(biosAiUpdateStartedAt)
    : null;
  const aiUpdateInProgress =
    aiUpdateStartedAt &&
    !Number.isNaN(aiUpdateStartedAt.getTime()) &&
    Date.now() - aiUpdateStartedAt.getTime() < 30 * 60 * 1000;
  const aiButtonDisabled =
    isGeneratingStory || Boolean(biosAiUpdatedAt) || Boolean(aiUpdateInProgress);

  const handleToggleEstado = async () => {
    if (isTogglingEstado) return;

    setIsTogglingEstado(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}api/perfiles/maestras/${maestraRut}/toggle_estado/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrfToken,
          },
          credentials: "include",
        },
      );

      if (!response.ok) {
        throw new Error("Failed to toggle estado");
      }

      const data = await response.json();
      onEstadoUpdate?.(data.e_relacion);
      onBiosUpdate?.();
    } catch (error) {
      console.error("Error toggling estado:", error);
    } finally {
      setIsTogglingEstado(false);
    }
  };

  const handleGenerateStory = async () => {
    if (aiButtonDisabled) return;

    const confirmed = window.confirm(
      "¿Seguro que quieres actualizar la historia de vida usando AI? Esta acción solo se puede ejecutar una vez por Maestra.",
    );

    if (!confirmed) return;

    setIsGeneratingStory(true);
    setStoryError("");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}api/perfiles/maestras/${maestraRut}/generar_historia_ai/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrfToken,
          },
          credentials: "include",
        },
      );

      const data = await response.json();

      if (!response.ok) {
        setStoryError(
          data?.error || "No se pudo actualizar la historia de vida con AI.",
        );
        return;
      }

      onBiosUpdate?.(data);
    } catch (error) {
      console.error("Error generating story:", error);
      setStoryError("Error de conexión al actualizar la historia de vida.");
    } finally {
      setIsGeneratingStory(false);
    }
  };

  const tipoClass = tipo ? tipo.toLowerCase().replace(" ", "-") : "";
  const relacionClass = relacion ? relacion.toLowerCase().replace(" ", "-") : "";

  return (
    <>
      <div id="maestra-badge">
        <div className={`maestra-badge-tipo ${tipoClass}`}>
          <span>Tipo de Perfil:</span>
          <span>{tipo}</span>
        </div>

        <div
          className={`maestra-badge-relacion ${relacionClass}`}
          onClick={handleToggleEstado}
          style={{ cursor: "pointer" }}
          title="Click to toggle Estado (OK / Problema)"
        >
          <span>Estado:</span>
          <span>{isTogglingEstado ? "Actualizando..." : relacion || "OK"}</span>
        </div>
      </div>

      <div className="maestra-bios-section">
        <div className="maestra-bios-header">
          <div>
            <span>Historia de vida</span>
            <small>
              {biosAiUpdatedAt
                ? "Actualizada por AI"
                : "Lectura protegida"}
            </small>
          </div>

          <button
            type="button"
            className="maestra-bios-ai-button"
            onClick={handleGenerateStory}
            disabled={aiButtonDisabled}
            title={
              biosAiUpdatedAt
                ? "La historia ya fue actualizada con AI"
                : "Actualizar historia con AI"
            }
          >
            <BsArrowClockwise />
          </button>
        </div>

        {storyError && <p className="maestra-bios-error">{storyError}</p>}

        <p className="maestra-bios-text">
          {isGeneratingStory
            ? "Generando historia de vida con AI..."
            : bios || "Historia de vida pendiente de generación."}
        </p>
      </div>
    </>
  );
}

export default Bios;
